import BinaryValue from "../model/BinaryValue";
import { isImmediateFlagSet, removeFlags } from "../util/instruction";
import { opcode } from "./InstructionSet";
/** Represents a value stored in the ram */
export default class Instruction extends BinaryValue {
    /**
     * @param {string} symOpc - The symbolic representation of the first byte of the instruction
     * @param {string} symOpr - The symbolic representation of the second byte of the instruction
     * @param {BinaryValue} value - The numberic value of the instruction
     * @param {boolean} invalidate - If set to true invalidates the instruction, setting its opcode to undefined. false by default
     */
    constructor(symOpc, symOpr, value, invalidate = false) {
        super(16, value);
        this.opcode = opcode(removeFlags(value));
        this.symbolicOpcode = symOpc;
        this.symbolicOperand = symOpr;
        if (invalidate) {
            this.opcode = undefined;
        }
    }
    /**
     * Returns true if the immediate flag of its instance is set
     * @returns {boolean}
     */
    immediateFlag() {
        return isImmediateFlagSet(this);
    }
    /**
     * Returns the first byte (the byte representing the opcode) of its instance
     * @returns {BinaryValue}
     */
    opcodeValue() {
        return this.getByte(1);
    }
    /**
     * Returns the second byte (the byte representing the operand) of its instance
     * @returns {BinaryValue}
     */
    operandValue() {
        return this.getByte(2);
    }
    /**
     * Returns the numeric value (signed) of the first byte (the byte representing the opcode) of its instance
     * @returns {number}
     */
    numericOpcode() {
        return this.getByte(1).signed();
    }
    /**
     * Returns the numeric value (signed if the immediate flag is set, unsigned otherwise)
     * of the second byte (the byte representing the operand) of its instance
     * @returns {number}
     */
    numericOperand() {
        return this.immediateFlag() ? this.getByte(2).signed() : this.getByte(2).unsigned();
    }
    /**
     * Returns a binary string representing the first byte (the byte representing the opcode) of its instance
     * @returns {string}
     */
    binaryOpcode() {
        return this.getByte(1).toBinaryString();
    }
    /**
     * Returns a binary string representing the second byte (the byte representing the operand) of its instance
     * @returns {string}
     */
    binaryOperand() {
        return this.getByte(2).toBinaryString();
    }
    /**
     * Returns the symbolic representation of its instance
     * @returns {string}
     */
    symbolic() {
        return this.symbolicOpcode + (this.symbolicOperand !== "" ? ` ${this.symbolicOperand}` : "");
    }
}
Instruction.NOP = new Instruction("NOP", "", new BinaryValue(16, opcode("NOP").numeric));
